import { useState } from "react";
import { ChatsCircle, Newspaper, Stack } from "@phosphor-icons/react";
import { useFetch, fmtDate } from "@/lib/api";
import { Badge, Empty } from "@/components/common";
import { Chips } from "@/components/studio/kit";

const ICON = { social: ChatsCircle, carousel: Stack, newsletter: Newspaper };
const Stat = ({ label, v, testid }) => (
  <div className="border border-border rounded-md bg-[#121212] p-4" data-testid={testid}>
    <div className="font-mono text-[11px] uppercase tracking-wider text-zinc-500">{label}</div>
    <div className="text-3xl font-semibold mt-1">{v}</div>
  </div>
);

export const Performance = () => {
  const [days, setDays] = useState("90 days");
  const { data } = useFetch(`/studio/performance?days=${parseInt(days, 10)}`);
  if (!data) return <div className="text-zinc-500 font-mono text-sm caret">Loading performance</div>;
  return (
    <div className="space-y-4" data-testid="performance-tab">
      <div className="flex items-center gap-3"><Chips value={days} onChange={setDays} options={["30 days", "90 days", "365 days"]} testid="perf-range" /><span className="text-[11px] text-zinc-500">{data.note}</span></div>
      <div className="grid grid-cols-3 gap-3">
        <Stat label="Tracked clicks" v={data.totals.clicks} testid="perf-total-clicks" />
        <Stat label={`Replies (≤${data.window_days} days)`} v={data.totals.replies} testid="perf-total-replies" />
        <Stat label={`Meetings (≤${data.window_days} days)`} v={data.totals.meetings} testid="perf-total-meetings" />
      </div>
      {!data.rows.length ? <Empty>Approve or send content to start tracking.</Empty> : (
        <div className="border border-border rounded-md overflow-hidden">
          <table className="w-full text-sm" data-testid="perf-table">
            <thead className="bg-[#121212] text-[11px] uppercase tracking-wider text-zinc-500 font-mono"><tr>
              {["Content", "Date", "Reach", "Clicks", "By channel", "Replies", "Meetings"].map((h) => <th key={h} className="text-left px-3 py-2 font-normal">{h}</th>)}
            </tr></thead>
            <tbody>{data.rows.map((r) => { const I = ICON[r.kind]; return (
              <tr key={r.id} className="border-t border-border/60 hover:bg-white/[0.02]" data-testid={`perf-row-${r.id}`}>
                <td className="px-3 py-2.5 max-w-[380px]"><div className="flex items-center gap-2"><I size={15} className="text-[#007AFF] shrink-0" /><span className="truncate">{r.title}</span><Badge v={r.kind} /></div></td>
                <td className="px-3 py-2.5 text-xs text-zinc-400 whitespace-nowrap">{fmtDate(r.at)}</td>
                <td className="px-3 py-2.5 font-mono">{r.reach ?? "—"}</td>
                <td className="px-3 py-2.5 font-mono">{r.clicks}<span className="text-zinc-500 text-[11px]"> ({r.unique_clicks} unique)</span></td>
                <td className="px-3 py-2.5 text-[11px] font-mono text-zinc-400">{Object.entries(r.by_channel).map(([k, v]) => `${k} ${v}`).join(" · ") || "—"}</td>
                <td className="px-3 py-2.5 font-mono">{r.replies}</td>
                <td className={`px-3 py-2.5 font-mono ${r.meetings ? "text-[#00C781] font-semibold" : ""}`}>{r.meetings}</td>
              </tr>); })}</tbody>
          </table>
        </div>
      )}
    </div>
  );
};
